import axios from 'axios'

const axiosConfig = axios.create({
    baseURL: 'https://beta.belovedmuhammad.com/api'
})

export default axiosConfig
